import React, { useCallback, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { TaskStatus } from 'nekst-api';
import { ProjectDetailFieldRow } from './types';

export function useCompletedDatesFilter(fields: ProjectDetailFieldRow[]) {
  const [showCompleted, setShowCompleted] = useState(false);

  const activeFields = fields.filter(
    (f) => f.linkedTask?.status !== TaskStatus.COMPLETED,
  );
  const completedCount = fields.length - activeFields.length;
  const visibleFields = showCompleted ? fields : activeFields;

  const getRowClassName = useCallback((data: ProjectDetailFieldRow) => {
    if (data.linkedTask?.status === TaskStatus.COMPLETED) {
      return 'opacity-50';
    } else {
      return undefined;
    }
  }, []);

  return { visibleFields, getRowClassName, completedCount, showCompleted, setShowCompleted };
}

export default function CompletedDatesToggle(props: {
  completedCount: number;
  showCompleted: boolean;
  onToggle: () => void;
}) {
  if (props.completedCount === 0) {
    return null;
  }

  const label = props.showCompleted
    ? 'Hide completed'
    : `Show ${props.completedCount} completed dates`;

  return (
    <div className="pb-2">
      <button
        type="button"
        onClick={props.onToggle}
        className="text-app-xs text-blue-500 hover:text-blue-700 mt-2 px-2 cursor-pointer flex items-center gap-1"
      >
        {props.showCompleted
          ? <EyeOff className="size-3.5 mr-1" />
          : <Eye className="size-3.5 mr-1" />}
        {label}
      </button>
    </div>
  );
}
